export const MAX_POPUP_NOTIFICATION_LAYER = 3

export const MIN_NOTIFICATION_SIZE = 25
export const MAX_NOTIFICATION_SIZE = 100

export const NOTIFICATION_STATUS_MAP = {
  new: 'NEW',
  partialFilled: 'PARTIAL_FILLED',
  filled: 'FILLED',
  cancelled: 'CANCELLED',
  replaced: 'REPLACED',
  rejected: 'REJECTED'
}

export const NOTIFICATION_TEXT_MAP = {
  [NOTIFICATION_STATUS_MAP.new]: 'Order created',
  [NOTIFICATION_STATUS_MAP.partialFilled]: 'Partial filled',
  [NOTIFICATION_STATUS_MAP.filled]: 'Order filled',
  [NOTIFICATION_STATUS_MAP.cancelled]: 'Order cancelled',
  [NOTIFICATION_STATUS_MAP.replaced]: 'Order replaced',
  [NOTIFICATION_STATUS_MAP.rejected]: 'Order rejected'
}

export const CUSTOM_ERROR_MESSAGE_MAP = {
  '-1003': 'Exceeded the rate limit, please try again later.',
  '-1103':
    'You are out of price range, please try to get closer to the best price'
}
